import { useSelector, useDispatch } from "react-redux";
import { clearNotification } from "../../reducers/App";
import { Alert, Snackbar } from "@mui/material";


const NotificationContainer = () => {
  const dispatch = useDispatch();
  const { notification } = useSelector(state => state.app);

  const handleClose = (event, reason) => {
    // Не закрываем при клике вне области
    if (reason === 'clickaway') return;

    dispatch(clearNotification());
  };

  return (
    <>
    {notification.isOpen && (
      <Snackbar
        open={notification.isOpen}
        autoHideDuration={3500}
        onClose={handleClose}
        onAutoHide={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity={notification.severity}>{notification.message || 'Произошла ошибка'}</Alert>
      </Snackbar>
    )}
    </>
  )

}

export default NotificationContainer